.wrapper {
  margin: 1rem 0;
}

.title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.row {
  display: grid;
  grid-template-columns: 2fr 1fr 2fr 1fr 48px;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--color-neutral-200);
  align-items: center;
}

.transferRow {
  grid-template-columns: 2fr 1fr 2fr 2fr 1fr 48px;
}

.row > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header {
  font-weight: 500;
  font-size: 0.875rem;
  color: #666;
  border-bottom: 2px solid var(--color-neutral-200);
  padding-top: 0;
}
